/**
 * Définition UNIQUE d'un contact VIP — miroir exact de Contact::isVip() backend.
 * Toute autre définition (quality_score > 80, catégorie seule…) est interdite :
 * quatre définitions divergentes coexistaient et l'aperçu ≠ l'envoi réel.
 */
export const isVip = (c) => c?.category === 'VIP' || (c?.engagement_score ?? 0) >= 75;
